import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ListIcon from '@material-ui/icons/List';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import EmojiEventsOutlinedIcon from '@material-ui/icons/EmojiEventsOutlined';
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined';
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import BlockIcon from '@material-ui/icons/Block';
import ErrorIcon from '@material-ui/icons/Error';

import { makeStyles } from '@material-ui/core/styles';
import { blue, green, orange, red } from '@material-ui/core/colors';

import ContextoService from '../../services/Contexto';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Toast from "../../components/Toast/Toast";
import { ButtonPrimary } from "../../components/Button/Button";
import { ContextDispatcher } from '../../components/Dispatcher/Dispatcher';
import Loading from '../../components/Loading/Loading';
import Categoria from '../../components/Categoria/Categoria';
import PopUpLegenda from '../../components/Legenda/PopUpLegenda';

import { DialogConfirm as DialogConfirmarMudanca } from '../../forms/Dialog/DialogConfirm';

import { patternContext } from '../../variables/Enums/Contexto';
import { patternEnum } from '../../variables/Enums/Enum';

import AuthorizedElement from '../../security/AuthorizedElement';
import AuthorizedFunction from '../../security/AuthorizedFunction';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

import {
    isBlank,
    isBlankHelperText,
    isNumber,
    isDateTimeHelperText,
    isDateTimeInvalid,
} from '../../helper/ValidationHelper';
import { toDateTime, parseDateTime } from '../../helper/DateHelper';

import { Layout } from '../../layouts/private/Private';

export const useStyles = makeStyles(theme => ({
    body: {
        margin: theme.spacing(3, 0),
    },
    legenda: {
        padding: "16px",
        "& ul": {
            paddingInlineStart: "16px",
        },
    },
    info: {
        backgroundColor: blue[400],
        color: "#fff",
    },
    success: {
        backgroundColor: green[400],
        color: "#fff",
    },
    warning: {
        backgroundColor: orange[400],
        color: "#fff",
    },
    error: {
        backgroundColor: red[400],
        color: "#fff",
    },
    white: {
        color: "#fff",
    },
    black: {
        color: "#000",
    }
}));

const ButtonList = () => {
    const classes = useStyles();
    return (
        <Grid item sm={12} lg={2} className={classes.body}>
            <ButtonPrimary
                to='/admin/contexto/listagem'
                component={Link}
                startIcon={<ListIcon />}
                name="Listagem de Variáveis"
            />
        </Grid>
    )
}

const ChipToken = ({ token, status = false }) => {
    const classes = useStyles();
    return (
        <>
            <Chip
                size="small"
                icon={status ? <DoneIcon className={classes.white} /> : !token ? <ErrorIcon className={classes.white} /> : <BlockIcon className={classes.black} />}
                label={<b>{status ? `Habilitado` : !token ? `Não Integrado` : `Desabilitado`}</b>}
                className={status ? classes.success : !token ? classes.error : null}
            />
        </>
    )
}

class Contexto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contexts: [],
            errors: {},
            helpers: {},
            loading: true,
            integracoes: [],
            optionsType: [],
            optionsGrupoExibicao: [],
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            contexts: [...this.state.contexts.filter(c => {
                if (c.name === e.target.name)
                    if (c.type !== "NUMERICO" || (c.type === "NUMERICO" && !isNumber(e.target.value)))
                        c.value = e.target.value;
                return true
            })
            ],
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null }
        });
    };

    // INPUTS DATE TIME PICKER
    handleChangeDateTime = (e, name) => {
        this.setState({
            contexts: [...this.state.contexts.filter(c => {
                if (c.name === name) c.value = toDateTime(e);
                return true
            })
            ],
            errors: { ...this.state.errors, [name]: false },
            helpers: { ...this.state.helpers, [name]: null }
        });
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;
    setDialogConfirmarMudanca = d => this.DialogConfirmarMudanca = d;

    // MONTAR VARIAVEIS
    fieldsContext = (grupo = null, icone = null, expanded = false) => {
        const contextos = this.state.contexts.filter(ctx => ctx.grupoExibicao === grupo);

        if (contextos.length > 0) {
            return (
                <Categoria nome={patternEnum(grupo, this.state.optionsGrupoExibicao)} icone={icone} defaultExpanded={expanded}>
                    <Grid container spacing={3} >
                        {contextos.map((c) => {
                            return (
                                <ContextDispatcher
                                    context={c}
                                    key={c.id}
                                    required
                                    label={c.label}
                                    name={c.name}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        c.type === "DATA_HORA" ? this.handleChangeDateTime(e, c.name) : this.handleChange(e);
                                        this.handleBlur(c.id);
                                    }}
                                    disabled={!AuthorizedFunction([__ADMINISTRADOR, __CENTRAL]) || c.grupoExibicao === "INTEGRACAO"}
                                    value={ c.type === "DATA_HORA" ? parseDateTime(c.value) : c.value}
                                    error={this.state.errors[c.name]}
                                    helperText={this.state.helpers[c.name]}
                                >
                                    {c.legenda && <PopUpLegenda texto={c.legenda} />}
                                </ContextDispatcher>
                            )
                        })}
                    </Grid>
                </Categoria>
            )
        }
    }

    fieldsContextToken = (grupo = null, icone = null, expanded = false) => {
        const contextos = this.state.contexts.filter(ctx => ctx.grupoExibicao === grupo);

        if (contextos.length > 0) {
            return (
                <Categoria nome={patternEnum(grupo, this.state.optionsGrupoExibicao)} icone={icone} defaultExpanded={expanded}>
                    <Grid container spacing={3} style={{ paddingTop: 2 }}>
                        {contextos.map((c) => 
                            <Grid item sm={12} lg={3}>
                                <Typography variant="body2" style={{ display: 'inline' }}>
                                    <b>{c.label}</b>:
                                </Typography> &nbsp;
                                
                                <ChipToken 
                                    token={c.value} 
                                    status={this.state.integracoes.find(i => i.id === c.id)?.status} 
                                /> &nbsp;

                                {c.legenda && <PopUpLegenda texto={c.legenda} />}
                            </Grid>
                        )}
                    </Grid>
                </Categoria>
            )
        }
    }

    // VALIDAÇÃO
    isValid = c => {
        if (isBlank(c.value)) {
            this.setState({
                errors: { ...this.state.errors, [c.name]: true },
                helpers: { ...this.state.helpers, [c.name]: isBlankHelperText() }
            })
            return false
        } else if (c.type === "DATA_HORA" && isDateTimeInvalid(parseDateTime(c.value))) {
            this.setState({
                errors: { ...this.state.errors, [c.name]: true },
                helpers: { ...this.state.helpers, [c.name]: isDateTimeHelperText() }
            })
            return false
        }
        return true
    }

    // SALVAR CONTEXTO
    handleBlur = (id) => {
        const c = this.state.contexts.find(c => c.id === id);

        if (!this.isValid(c))
            return

        const context = {
            tipo: c.type,
            valor: c.value,
            variavel: c.label,
            ordemExibicao: c.ordem,
            legenda: c.legenda,
            agrupamento: c.grupoExibicao,
        }

        ContextoService.edit(c.id, context)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "Contexto Salvo com Sucesso",
                        type: "success",
                        open: true
                    }
                });
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
            .finally(() => this.DialogConfirmarMudanca.close());
    }

    async componentDidMount() {
        const tipos = await EnumService.listarTiposVariavel().then(res => res.data);
        const grupos = await EnumService.listarAgrupamentos().then(res => res.data);
        
        this.setState({ 
            optionsType: [...tipos], 
            optionsGrupoExibicao: [...grupos], 
        });

        let f = [];
        f.push({ field: 'sort', value: 'ordemExibicao,asc' });

        ContextoService.filters(f)
            .then(res => {
                if (res.data.content) {
                    const contexts = patternContext(res.data.content);

                    let errors = {};
                    contexts.forEach(context => { errors[context.name] = false });

                    let helpers = {};
                    contexts.forEach(context => { helpers[context.name] = null });

                    this.setState({
                        contexts: [...this.state.contexts, ...contexts],
                        errors: errors,
                        helpers: helpers,
                        loading: false,
                    });
                } else {
                    this.setState({
                        contexts: [],
                        errors: {},
                        helpers: {},
                        loading: false,
                    });
                }
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })

                this.setState({ loading: false, });
            })

        ContextoService.verificarIntegracoes()
            .then(res => {
                this.setState({
                    integracoes: [...res.data],
                })
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: "Não foi Possível Buscar o Status das Integrações",
                        type: e.type,
                        open: true
                    }
                })
            })
    }

    render() {
        const page = 'Contexto';
        const links = [
            {
                path: null,
                name: 'Configurações'
            }
        ];

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={page} />
                    </Grid>
                </Grid>
                <Title>{page}</Title>

                <Grid container style={{ marginBottom: 16 }}>
                    <AuthorizedElement roles={[__ADMINISTRADOR]}>
                        <ButtonList />
                    </AuthorizedElement>
                </Grid>

                {this.state.loading ? 
                    <Loading /> 
                : 
                    <>
                        {this.fieldsContext("GERAL", <SettingsOutlinedIcon />)}
                        {this.fieldsContext("INSCRICAO", <ScheduleOutlinedIcon />)}
                        {this.fieldsContext("CONFIRMACAO", <DateRangeOutlinedIcon />)}
                        {this.fieldsContext("PROVA", <DateRangeOutlinedIcon />)}
                        {this.fieldsContext("PREMIACAO", <EmojiEventsOutlinedIcon />)}

                        {this.fieldsContextToken("INTEGRACAO", <AccountTreeOutlinedIcon />)}

                        {this.fieldsContext()}
                    </>
                }

                <DialogConfirmarMudanca
                    parentRef={this.setDialogConfirmarMudanca}
                    handleConfirm={this.handleBlur}
                />
            </Layout >
        )
    }
}

export default Contexto;